import type { FichaSectionKind } from "../ficha-secao";

export const FICHA_MENU_LABEL = "Seções da ficha";

export interface FichaSectionDefinition {
  id: string;
  title: string;
  kind: FichaSectionKind;
  /** Chaves de `dadosFicha` que podem trazer o conteúdo da seção (primeira que existir). */
  dataKeys: string[];
}

/** As 8 seções da ficha, na ordem do menu lateral. */
export const FICHA_SECTIONS: readonly FichaSectionDefinition[] = [
  {
    id: "identificacao",
    title: "Identificação da Obra",
    kind: "campos",
    dataKeys: ["identificacaoObra", "identificacao"],
  },
  {
    id: "datas",
    title: "Datas e Planejamento",
    kind: "campos",
    dataKeys: ["datasPlanejamento", "datasEPlanejamento", "datas", "planejamento"],
  },
  { id: "contrato", title: "Contrato", kind: "campos", dataKeys: ["contrato"] },
  {
    id: "custos",
    title: "Custos e Financeiro",
    kind: "custos",
    dataKeys: ["custosFinanceiro", "custosEFinanceiro", "custos", "financeiro"],
  },
  {
    id: "orcamento",
    title: "Orçamento por Coletor",
    kind: "orcamento",
    dataKeys: ["orcamentoPorColetor", "orcamentoColetor", "orcamentoColetores", "coletores"],
  },
  {
    id: "responsaveis",
    title: "Responsáveis e Governança",
    kind: "campos",
    dataKeys: ["responsaveisGovernanca", "responsaveisEGovernanca", "responsaveis", "governanca"],
  },
  {
    id: "embarcacao",
    title: "Informações da Embarcação",
    kind: "campos",
    dataKeys: ["informacoesEmbarcacao", "embarcacao"],
  },
  { id: "anexos", title: "Anexos", kind: "anexos", dataKeys: ["anexos"] },
];

/** Seções lidas só do banco: o JSON de `dadosFicha` não acrescenta campos a elas. */
export const DB_ONLY_SECTION_IDS: ReadonlySet<string> = new Set([
  "identificacao",
  "datas",
  "contrato",
  "custos",
  "embarcacao",
]);

export const CONDICAO_DRY_DOCKING = "Seco (Dry Docking)";
export const NAO_APLICAVEL = "N/A";

/** Prefixo do título da ficha no assunto, no corpo do e-mail e no nome do arquivo (HU 2689). */
export const FICHA_EMAIL_CORPO_PREFIXO = "Ficha Financeira da Obra";

/** Cc fixo do e-mail à controladoria; editar a lista é melhoria futura (HU 2689). */
export const FICHA_EMAIL_CC: readonly string[] = [
  "juliano.lumazini@oceanpact.com",
  "marcelo.cardoso@oceanpact.com",
  "lmoura@oceanpact.com",
  "pedro.ariel@oceanpact.com",
];

export const FICHA_EXPORT_ESCOPO =
  "A exportação traz a ficha financeira completa, com todas as seções.";
export const FICHA_EXPORT_SUCESSO = "Ficha exportada.";
export const FICHA_EXPORT_ERRO = "Não foi possível exportar a ficha. Tente novamente.";

/** MS005: explicação do N/A fora de Dry Docking (RN010). */
export const NAO_APLICAVEL_MENSAGEM = "Não se aplica: a obra não é em seco (Dry Docking).";

export const PREVIA_CANCELAR_LABEL = "Cancelar";
export const PREVIA_SALVAR_LABEL = "Salvar";
export const PREVIA_FECHAR_LABEL = "Fechar";
/** Ficha salva: o toast fica na tela por 4 segundos. */
export const FICHA_SALVA_MESSAGE = "Ficha salva.";
export const FICHA_SALVA_LIFE = 4000;
export const FICHA_SALVAR_ERRO_LIFE = 5000;

/** Campos de responsável: pesquisam usuários do Hub; os demais editáveis são texto simples. */
export const CAMPOS_USUARIO: ReadonlySet<string> = new Set([
  "diretorProjeto",
  "responsavelPreparacao",
  "responsavelExecucao",
  "coordenador",
]);

export const FICHA_LOADING_LABEL = "Carregando ficha...";
